import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import merge from 'lodash/merge';
import { chartSectionStyles, sectionLgPadding, widgetConfig } from './configs';
import { resetConfigStyles as resetLineChartConfigStyles } from '@/components/widget/visualizations/internal/LineChart/stylesTheme'; // Ensure that the widget has the default chart builder settings

export const withChartBuilderDefaults = (widget, sectionId) => {
  return merge({}, widget, {
    config: widgetConfig,
    sections: {
      [sectionId]: {
        config: {
          styles: _objectSpread(_objectSpread({}, chartSectionStyles), sectionLgPadding)
        }
      }
    }
  });
}; // Reset the section styles to the defaults

export const resetSectionConfigStyles = (widget, sectionId) => {
  var _widget$sections;

  const section = (_widget$sections = widget.sections) === null || _widget$sections === void 0 ? void 0 : _widget$sections[sectionId];
  if (!(section !== null && section !== void 0 && section.config)) return null;
  const resetConfigStyles = {
    LineChart: resetLineChartConfigStyles
  }[section === null || section === void 0 ? void 0 : section.component];
  if (!resetConfigStyles) return null;
  return resetConfigStyles(section.config);
};